var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assets-item-card"},[_c('div',{staticClass:"card-content"},[(_vm.item.image_url)?_c('div',[_c('img',{attrs:{"src":_vm.item.image_url,"alt":""}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-label",attrs:{"title":_vm.item.file_name}},[_vm._v("\n    "+_vm._s(_vm.item.file_name)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }